import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { cartClient } from "@core/clients";
import { CreateSharedCartPayload } from "./types";
import { SharedCart } from "@core/types";

const useCreateSharedCartMutation = (
  options?: Omit<UseMutationOptions<SharedCart | null, Error, CreateSharedCartPayload>, "mutationFn" | "mutationKey">,
) => {
  return useMutation({
    mutationKey: ["shared-cart", "create"],
    mutationFn: (cart: CreateSharedCartPayload) => cartClient.createSharedCart(cart),
    ...options,
  });
};

export default useCreateSharedCartMutation;
